import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { appLinkTarget } from './appLinkRules';

type LaunchParams = { targetURL?: string };
type LaunchQueue = { setConsumer: (consumer: (params: LaunchParams) => void) => void };

/**
 * Opens a Hub link handed to the already-open Hub app (Chrome and Edge `launchQueue`) inside the
 * app, without a page reload, so the order alarm and its sound stay armed.
 */
const AppLinkHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const current = useRef('');
  current.current = location.pathname + location.search + location.hash;

  useEffect(() => {
    const queue = (window as Window & { launchQueue?: LaunchQueue }).launchQueue;
    queue?.setConsumer(params => {
      if (!params.targetURL) return;
      const target = appLinkTarget(params.targetURL, window.location.origin, current.current);
      if (target) navigate(target);
    });
  }, [navigate]);

  return null;
};

export default AppLinkHandler;
